<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ProductCategory',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'name',
        placeholder: '商品名称',
        type: 'input',
      }],
      permission: {
        add: 'productCategory:add',
        update: 'productCategory:update',
        delete: 'productCategory:delete',
        deleteBatch: 'productCategory:deleteBatch'
      },
      url: {
        get: '/productCategory/listByCondition',
        add: '/productCategory/add',
        update: '/productCategory/update',
        delete: '/productCategory/delete',
        delete_batch: '/productCategory/deleteBatch',
        status: '/productCategory/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },{
        field: 'name',  // 字段名
        label: '名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'sort',  // 字段名
        label: '排序',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: false, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'name',  // 字段名
            label: '名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入名称',
            rules: [
              {required: false, message: '名称不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'sort',  // 字段名
            label: '排序',  // 字段显示名称
            type: 'input',
            placeholder: '请输入排序',
            rules: [
              {required: false, message: '排序不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
